import accounttypeReducer from './accounttype/reducer';
import approvaldocsReducer from './approvaldocs/reducer';
import admindataissuemaintenancemodeReducer from './admindataissuemaintenancemode/reducer';
import adminmaintenancemodeReducer from './adminmaintenancemode/reducer';
import adminTabReducer from './adminTab/reducer';
import adminusersReducer from './adminusers/reducer';
import adviserContactsReducer from './adviserContacts/reducer';
import advisersReducer from './advisers/reducer';
import contactsReducer from './contacts/reducer';
import changepasswordReducer from './changepassword/reducer';
import dashboardassetallocationsReducer from './dashboardassetallocations/reducer';
import dashboardperformanceReducer from './dashboardperformance/reducer';
import dashboardReducer from './dashboard/reducer';
import dashboardvalueovertimeReducer from './dashboardvalueovertime/reducer';
import dataissuemaintenancemodeReducer from './dataissuemaintenancemode/reducer';
import documentsReducer from './documents/reducer';
import documentsAdvisersReducer from './documentsadvisers/reducer';
import importsReducer from './imports/reducer';
import maintenancemodeReducer from './maintenancemode/reducer';
import navigationdrawerReducer from './navigationdrawer/reducer';
import notificationdrawerReducer from './notificationdrawer/reducer';
import notificationsReducer from './notifications/reducer';
import passwordpolicyReducer from './passwordpolicy/reducer';
import planassetallocationsReducer from './planassetallocations/reducer';
import plancontributionsandwithdrawalsReducer from './plancontributionsandwithdrawals/reducer';
import planholdingsReducer from './planholdings/reducer';
import planperformanceReducer from './planperformance/reducer';
import plantransactionsReducer from './plantransactions/reducer';
import planvalueovertimeReducer from './planvalueovertime/reducer';
import planwithdrawableReducer from './planwithdrawable/reducer';
import planisasubReducer from './planisasub/reducer';
import saltusownersReducer from './saltusowners/reducer';
import selectedReducer from './selected/reducer';
import sessionReducer from './session/reducer';
import signatureReducer from './actioncentersignature/reducer';
import teammemberinfoReducer from './teammemberinfo/reducer';
import themeReducer from './theme/reducer';
import clientdocumentanalyticsReducer from './clientdocumentanalytics/reducer';
import clientwithdrawalsReducer from './clientwithdrawals/reducer';
import clientwithdrawalattemptsReducer from './clientwithdrawalattempts/reducer';
import clientwithdrawalsallowReducer from './clientwithdrawalsallow/reducer';
import adviserdocumentanalyticsReducer from './adviserdocumentanalytics/reducer';
import atrReducer from './atr/reducer';
import adhoc2faReducer from './adhoc2fa/reducer';
import formReducer from './form/reducer';
import adminportalalertReducer from './adminportalalert/reducer';

const reducers = {
  accounttype: accounttypeReducer,
  approvaldocs: approvaldocsReducer,
  adminTab: adminTabReducer,
  adminusers: adminusersReducer,
  adminmaintenancemode: adminmaintenancemodeReducer,
  admindataissuemaintenancemode: admindataissuemaintenancemodeReducer,
  advisers: advisersReducer,
  adviserContacts: adviserContactsReducer,
  contacts: contactsReducer,
  changepassword: changepasswordReducer,
  dashboard: dashboardReducer,
  dashboardassetallocations: dashboardassetallocationsReducer,
  dashboardvalueovertime: dashboardvalueovertimeReducer,
  dashboardperformance: dashboardperformanceReducer,
  dataissuemaintenancemode: dataissuemaintenancemodeReducer,
  documents: documentsReducer,
  documentsAdvisers: documentsAdvisersReducer,
  imports: importsReducer,
  maintenancemode: maintenancemodeReducer,
  navigationdrawer: navigationdrawerReducer,
  notificationdrawer: notificationdrawerReducer,
  notifications: notificationsReducer,
  passwordpolicy: passwordpolicyReducer,
  planassetallocations: planassetallocationsReducer,
  plancontributionsandwithdrawals: plancontributionsandwithdrawalsReducer,
  planisasub: planisasubReducer,
  planholdings: planholdingsReducer,
  planperformance: planperformanceReducer,
  plantransactions: plantransactionsReducer,
  planvalueovertime: planvalueovertimeReducer,
  saltusowners: saltusownersReducer,
  selected: selectedReducer,
  session: sessionReducer,
  signatureData: signatureReducer,
  teammemberinfo: teammemberinfoReducer,
  clientdocumentanalytics: clientdocumentanalyticsReducer,
  clientwithdrawals: clientwithdrawalsReducer,
  clientwithdrawalattempts: clientwithdrawalattemptsReducer,
  clientwithdrawalsallow: clientwithdrawalsallowReducer,
  adviserdocumentanalytics: adviserdocumentanalyticsReducer,
  adhoc2fa: adhoc2faReducer,
  theme: themeReducer,
  atr: atrReducer,
  planwithdrawable: planwithdrawableReducer,
  form: formReducer,
  adminportalalert: adminportalalertReducer,
};

export default reducers;
